export enum AuthFromTypeEnum {
  LOGIN = 'Login',
  CHANGE_PASSWORD = 'ChangePassword'
}



// WEBPACK FOOTER //
// ./src/app/enums/authFromTypeEnum.enum.ts